import cn from 'classnames';
import {
  FilterItems,
  ResetButtonFilterItemConfigProps,
} from '@odin-labs/components';
import { PageSearchParams } from 'utils';
import { Moment } from 'moment';
import { CalendarDayIcon } from 'components/icons';
import { TimeSeries } from 'apollo/generated/client-operations';

export const STAT_PLACEHOLDER = '—';

export const sumTimeSeriesValues = (ts: TimeSeries[]): number =>
  ts.reduce((sum, d) => sum + d.value, 0);

export const peakTimeSeriesValue = (ts: TimeSeries[]): number =>
  ts.length === 0 ? 0 : Math.max(...ts.map((d) => d.value));

export type JobsiteOverviewFilters = Pick<
  Required<PageSearchParams>,
  'date'
> & {
  today: never;
};

export const getFilterItems = ({
  date,
  today,
}: {
  date: Moment | string;
  today: Moment;
}): FilterItems<JobsiteOverviewFilters> => {
  return {
    date: {
      header: 'Date',
      type: 'datePicker',
      defaultValue: date,
      layout: cn('odin-col-span-full'),
      componentProps: {
        isRange: false,
      },
    },
    today: {
      header: 'Today',
      type: 'resetButton',
      componentProps: (
        filterValues: JobsiteOverviewFilters,
      ): ResetButtonFilterItemConfigProps => {
        return {
          icon: CalendarDayIcon,
          disabled: today.isSame(filterValues.date, 'day'),
          filtersValues: {
            date: today,
          },
        };
      },
    },
  };
};
